import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import UserProvider from "../providers/UserProvider";
import TransactionsManager from "../providers/TransactionsManager";
import Loading from "../components/Loading";

// Lazy load all page components for code splitting
const Home = lazy(() => import("../pages/Home"));
const FlexyWrapper = lazy(() => import("../pages/FlexyWrapper"));
const IdoomADSL = lazy(() => import("../pages/IdoomADSL"));
const Transactions = lazy(() => import("../pages/Transactions"));
const TransactionStatus = lazy(() => import("../pages/TransactionStatus"));
const Notfound = lazy(() => import("../pages/Notfound"));
const DjezzyFacture = lazy(() => import("../pages/DjezzyFacture"));
const Idoom4G = lazy(() => import("../pages/Idoom4G"));
const Rechargement = lazy(() => import("../pages/Rechargement"));
const PrepaidCards = lazy(() => import("../pages/PrepaidCards"));
const Settings = lazy(() => import("../pages/settings/Settings"));
const Store = lazy(() => import("../pages/store/Storepage"));
const Recharge = lazy(() => import("../pages/AccountRecharge/Recharge"));
const Tuto = lazy(() => import("../pages/tuto/Tuto"));
const GamesCards = lazy(() => import("../pages/games/GamesCards"));
const Debts = lazy(() => import('../pages/debts/Debtspage'));
const OffersPage = lazy(() => import("../pages/store/OffersPage"));

function AppNavigation() {

  return (
    <UserProvider>
      <TransactionsManager>
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <Routes>
            <Route exact path="/" element={<Home />} name="home" />
            <Route
              exact
              path="/flexy/:operator/:isnewoperation"
              element={<FlexyWrapper   />}
              name="flexy"
            />
            <Route
              exact
              path="/djezzyfacture/:operator/:isnewoperation"
              element={<DjezzyFacture  />}
              name="djezzyfacture"
            />
            <Route exact path="/idoom" element={<IdoomADSL />} name="idoom" />
            <Route
              exact
              path="/idoomfourg"
              element={<Idoom4G />}
              name="idoomfourg"
            />
            <Route
              exact
              path="/transactions"
              element={<Transactions />}
              name="transactions"
            />
            <Route
              exact
              path="/transactionstatus"
              element={<TransactionStatus />}
              name="transactionstatus"
            />
            <Route
              exact
              path="/store"
              element={<Store />}
              name="store"
            />
            <Route
              exact
              path="/storeoffers"
              element={<OffersPage />}
              name="storeoffers"
            />
            <Route
              exact
              path="/rechargements"
              element={<Rechargement />}
              name="rechargements"
            />
            <Route
              exact
              path="/prepaidcards/:operator"
              element={<PrepaidCards />}
              name="prepaidcards"
            />
            <Route
              exact
              path="/gamescards/:operator"
              element={<GamesCards />}
              name="gamescards"
            />
            <Route
              exact
              path="/settings"
              element={<Settings />}
              name="settings"
            />

            <Route
              exact
              path="/tutorials"
              element={<Tuto />}
              name="Tuto"
            />

            <Route
              exact
              path="/accountrechargement"
              element={<Recharge />}
              name="accountrechargement"
            />

          <Route
              exact
              path="/debts"
              element={<Debts />}
              name="debts"
            />

            <Route path="/404" element={<Notfound />} />

            <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TransactionsManager>
    </UserProvider>
  );
}

export default AppNavigation;
